/* global femcare */

$(window).on('load', function () {
    femcare.form.periodTracker.init(); // Deprecated period tracker
});
